module.exports = __webpack_public_path__ + "img/gc_country_flag_pt.44de6e10.svg";